/**
 * apps/web :: pass :: screens/courseware.routes
 *
 * Self-registering route descriptors for the light-courseware screens
 * (ROADS-569 W1.C5): the course overview at `learn` and the single
 * lesson at `learn/:lessonId`.
 */
import type { PassRouteDescriptor } from "../routeDescriptor";
import CoursewareCourse from "./CoursewareCourse";
import CoursewareLesson from "./CoursewareLesson";

export const coursewareRoutes: PassRouteDescriptor[] = [
  { path: "learn", element: <CoursewareCourse /> },
  { path: "learn/:lessonId", element: <CoursewareLesson /> },
];
